<template lang="pug">
section
  div
    | To be eligible you must:

  br

  ul
    li
      | be a genuine business;
    li
      | operate lawfully and have
      | a trading presence in the UK;
    li
      | not take part in any actions
      | that are conducive to the public good;
    li
      | be able to prove
      | that you can carry out
      | your sponsor duties and responsibilities;
    li
      | be able to prove the above points
      | by providing certain documents
      | to support your application.
</template>

<script>
export default {
  name: "criteria_eligibility",
};
</script>